import React, { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import { useMaterialUIController } from "../../../context";
import useApi from "../../../components/Utils/api";
import ConfiguratorRoot from "../../../examples/Configurator/ConfiguratorRoot";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { terminalSchema, terminalModel } from "../../../models/terminalSchema";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import CircularProgress from "@mui/material/CircularProgress";


function NewTerminal({openConfigurator, setOpenConfigurator, terminal, merchant, onTerminalCloseHandler, refreshMerchant}) {
  const [controller] = useMaterialUIController();
  const {user} = controller;
  const [devices, setDevices] = useState([]);
  const [isLoadingDevices, setIsLoadingDevices] = useState(false);
  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control, setValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(terminalSchema)
  });
  const selectedDeviceType = watch("deviceType");  
  useEffect(() => {
    if(Object.keys(terminal).length > 0 ){
      console.log("terminal",terminal)
      reset(terminal);
      
      // Check if device exists and set the device type and serial no
      if (terminal.device) {
        
        // Then set the serial number if it exists
        if (terminal.device.serialNo) {
          setValue("deviceSerialNo", terminal.device.serialNo);
        }
      }
    } else {
      reset(terminalModel);
      setValue("mid", merchant.merchant.mid);
      setValue("msisdn", merchant.merchant.mobileNo);
      setValue("emailtid", merchant.merchant.emailId);
    }
  }, [openConfigurator]);  // Fetch devices based on device type and reset device selection when type changes
  useEffect(() => {
    if (selectedDeviceType && selectedDeviceType !== '-1') {
      if (selectedDeviceType === 'ECOM' || selectedDeviceType === 'SOFTPOS') {
        // Reset the device selection when device type is ECOM or SOFTPOS
        setValue("deviceSerialNo", "");
      } else {
        fetchDevicesByType(selectedDeviceType);
      }
    }
  }, [selectedDeviceType]);

  const fetchDevicesByType = async (deviceType) => {
    setIsLoadingDevices(true);
    try {
      const response = await api.get("devices");
      if (response.data.data) {
        let filteredDevices = [];
        
        // Get the current terminal's device serial number if it exists
        const currentDeviceSerialNo = terminal.device?.serialNo;
        
        if (Object.keys(terminal).length > 0 && currentDeviceSerialNo) {
          // Include unmapped devices and the device that's currently assigned to this terminal
          filteredDevices = response.data.data.filter(
            device => 
              // Include unmapped active devices matching the type
              (!device.mappedTerminalid && device.status === 1 && device.model === deviceType) ||
              // Include the currently mapped device for this terminal
              (device.serialNo === currentDeviceSerialNo)
          );
        } else {
          // Just include unmapped devices for new terminals
          filteredDevices = response.data.data.filter(
            device => !device.mappedTerminalid && device.status === 1 && device.model === deviceType
          );
        }
        
        setDevices(filteredDevices);
      } else {
        toast.error("Failed to fetch device records");
      }
    } catch (error) {
      toast.error("Error fetching devices: " + (error.response?.data?.message || error.message));
    } finally {
      setIsLoadingDevices(false);
    }
  };
  const api = useApi();    const createTerminalHandler = (data) => {
    // For E-COMMERCE or SOFTPOS devices, we don't need a deviceSerialNo
    if (data.deviceType === 'ECOM' || data.deviceType === 'SOFTPOS') {
      data.deviceSerialNo = null;
    }
    
    api.post("terminal/create", data)
      .then((response) => {
        if(response.data.statusCodeValue === 200){
          toast.success("Terminal successfully created and a user has been added.");
          setOpenConfigurator(false);
          // window.location.reload();
          refreshMerchant();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response)
        toast.error(error.response.data.body)
      })
  }
  function handleCityChange(e) {
    const state = e.explicitOriginalTarget.getAttribute('data-state');
    const country = e.explicitOriginalTarget.getAttribute('data-country');
    setValue("state", state);
    setValue("country", country);
  }    function updateTerminalHandler(data) {
    // For E-COMMERCE or SOFTPOS devices, we don't need a deviceSerialNo
    if (data.deviceType === 'ECOM' || data.deviceType === 'SOFTPOS') {
      data.deviceSerialNo = null;
      delete data.device; // Remove it from the data object if it's not needed
    }
    
    api.post("terminal/update", data)
      .then(response => {
        if(response.data.statusCodeValue === 200) {
          toast.success("Terminal successfully updated.");
          reset(terminalModel);
          setOpenConfigurator(false);
          // window.location.reload();
          refreshMerchant();
        }
      })
      .catch(error => {
        console.log(error);
        toast.error(error.response?.data?.body || "Failed to update terminal");
      });
  }
  function submitHandler() {
    if(Object.keys(terminal).length === 0 ){
      handleSubmit(createTerminalHandler)();
    } else {
      handleSubmit(updateTerminalHandler)();
    }
  }

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">{Object.keys(terminal).length > 0 ? 'Update' : 'New'} Terminal</MDTypography>
          {/*<MDTypography variant="body2" color="text">*/}
          {/*  {updatedUser?.userId}*/}
          {/*</MDTypography>*/}
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => {
            setOpenConfigurator(false);
            onTerminalCloseHandler();
            }
          }
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <Grid container spacing={2} justifyContent="center">
        <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, control }}>
          <Grid item xs={6}>
            <MDInput
              type="text" label="Merchant Id" name="mid"
              error={errors.mid}
              helperText={errors.mid ? errors.mid.message : ''}
              fullWidth
              disabled
              {...register("mid")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput type="text" label="Moblie Number" name="msisdn"
                     error={errors.msisdn}
                     helperText={errors.msisdn ? errors.msisdn.message : ''}
                     fullWidth
                     required
                     {...register("msisdn")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput type="text" label="Terminal id/ Username" name="tid"
                     error={errors.tid}
                     helperText={errors.tid ? errors.tid.message : ''}
                     fullWidth
                     required
                     disabled={Object.keys(terminal).length > 0}
                     {...register("tid")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput type="text" label="Name" name="name"
                     error={errors.name}
                     helperText={errors.name ? errors.name.message : ''}
                     fullWidth
                     {...register("name")}
            />
          </Grid>

          {/*<Grid item xs={6}>*/}
          {/*  <FormControl fullWidth style={{height: '100%'}}>*/}
          {/*    <InputLabel>City</InputLabel>*/}
          {/*    <Controller*/}
          {/*      name="city"*/}
          {/*      control={control}*/}
          {/*      defaultValue=""*/}
          {/*      render={({ field }) => (*/}
          {/*        <Select*/}
          {/*          {...field}*/}
          {/*          style={{height: '100%'}}*/}
          {/*          onChange={(e) => {*/}
          {/*            field.onChange(e); // Default handler for react-hook-form*/}
          {/*            handleCityChange(e);*/}
          {/*          }}*/}
          {/*          input={<OutlinedInput label="City" />}*/}
          {/*        >*/}
          {/*          <MenuItem value="-1">- Select City -</MenuItem>*/}
          {/*          {merchant?.cityList.map(city => (*/}
          {/*            <MenuItem data-state={city.state} data-country={city.country} key={city.cityId} value={city.cityId}>{city.cityCode}</MenuItem>*/}
          {/*          ))}*/}
          {/*        </Select>*/}
          {/*      )}*/}
          {/*    />*/}
          {/*  </FormControl>*/}
          {/*</Grid>*/}

          {/*<Grid item xs={6}>*/}
          {/*  <MDInput type="text" label="State" name="state"*/}
          {/*           error={errors.state}*/}
          {/*           helperText={errors.state ? errors.state.message : ''}*/}
          {/*           fullWidth*/}
          {/*           disabled*/}
          {/*           {...register("state")}*/}
          {/*  />*/}
          {/*</Grid>*/}

          {/*<Grid item xs={6}>*/}
          {/*  <MDInput type="text" label="Country" name="country"*/}
          {/*           error={errors.country}*/}
          {/*           helperText={errors.country ? errors.country.message : ''}*/}
          {/*           fullWidth*/}
          {/*           disabled*/}
          {/*           {...register("country")}*/}
          {/*  />*/}
          {/*</Grid>*/}

          <Grid item xs={6}>
            <MDInput type="text" label="Store Name" name="storename"
                     error={errors.storename}
                     helperText={errors.storename ? errors.storename.message : ''}
                     fullWidth
                     {...register("storename")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput type="text" label="Store Address" name="storeaddress"
                     error={errors.storeaddress}
                     helperText={errors.storeaddress ? errors.storeaddress.message : ''}
                     fullWidth
                     {...register("storeaddress")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput type="email" label="Email" name="emailtid"
                     error={errors.emailtid}
                     helperText={errors.emailtid ? errors.emailtid.message : ''}
                     fullWidth
                     {...register("emailtid")}
            />
          </Grid>          
          <Grid item xs={6}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="devicetype">Device Type *</InputLabel>
              <Controller
                name="deviceType"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Select {...field} style={{height: '45px'}} label="Device Type *" required labelId="devicetype">
                    <MenuItem value="-1">- Select Device Type -</MenuItem>
                    {/* <MenuItem value="UCUBE_TOUCH">UCUBE_TOUCH</MenuItem> */}
                    <MenuItem value="SOFTPOS">SOFTPOS</MenuItem>
                    <MenuItem value="Y1000K">Y1000K</MenuItem>
                    <MenuItem value="ECOM">E-COMMERCE</MenuItem>
                  </Select>
                )}
                required
              />
            </FormControl>
          </Grid>
          
          <Grid item xs={12}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="deviceselect">Terminal Serial</InputLabel>
              <Controller
                name="deviceSerialNo"
                control={control}
                defaultValue=""
                render={({ field }) => (                  <Select 
                    {...field} 
                    style={{height: '45px'}} 
                    label="Terminal Serial "
                    labelId="deviceselect"
                    required={selectedDeviceType !== 'ECOM' && selectedDeviceType !== 'SOFTPOS'}
                    disabled={!selectedDeviceType || selectedDeviceType === '-1' || selectedDeviceType === 'ECOM' || selectedDeviceType === 'SOFTPOS'}
                  >
                    <MenuItem value="">- Select Serial -</MenuItem>                    
                    {isLoadingDevices ? (
                      <MenuItem value="" disabled>
                        <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                        Loading...
                      </MenuItem>
                    ) : devices.length > 0 ? (
                      devices.map((device) => (
                        <MenuItem key={device.serialNo} value={device.serialNo}>
                          {device?.deviceName} ({device?.serialNo})
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        No available devices found
                      </MenuItem>
                    )}
                  </Select>
                )}
                required={selectedDeviceType !== 'ECOM' && selectedDeviceType !== 'SOFTPOS'}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <MDButton onClick={() => submitHandler()} variant="gradient" color="info" style={{float : 'right'}}>
              {Object.keys(terminal).length > 0 ? 'Update' : 'Add'}
            </MDButton>
          </Grid>
        </FormProvider>
      </Grid>
    </ConfiguratorRoot>
  );
}

NewTerminal.defaultProps = {
  openConfigurator: false,
  setOpenConfigurator: false,
  terminal : {},
  merchant: {}
}

NewTerminal.propTypes = {
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func,
  terminal: PropTypes.object,
  merchant : PropTypes.object,
  onTerminalCloseHandler: PropTypes.func,
  refreshMerchant: PropTypes.func,
}

export default NewTerminal;